import { renderImage } from "../../../../utils/helper.jsx";
import React, { useEffect, useState } from "react";

function AttachmentDownload({ docs }) {
  const fileExt = docs.split(".").pop();
  const [isOpen, setIsOpen] = useState(false);
  //if fileExt is image render in img, but if not image just create a link to download
  return (
    <div>
      <a
        href={renderImage(`/machine/attachment/${docs}`)}
        target={"_blank"}
        download
      >
        <div style={{ display: "flex", cursor: "pointer" }}>
          <div style={{ display: "flex" }}>
            <div style={{ paddingTop: "3px", marginRight: "10px" }}>
              <img
                src="/img/attachment_icon.png"
                alt=""
                style={{ width: "12px" }}
              />
            </div>
            <div style={{ paddingTop: "3px" }}>Attachment</div>
          </div>
        </div>
      </a>
    </div>
  );
}

export default AttachmentDownload;
